import { render, staticRenderFns } from "./ButtonIconCopy.vue?vue&type=template&id=3402542b&scoped=true&"
import script from "./ButtonIconCopy.vue?vue&type=script&lang=js&"
export * from "./ButtonIconCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3402542b",
  null
  
)

export default component.exports